var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-image',{staticClass:"logo-size",attrs:{"src":"@/assets/images/logo/logo.png","alt":"logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }